import {
    createSelector,
} from '@reduxjs/toolkit';
import i18n from '~shared/utils/i18n';

import {
    selectUserSelectionById,
    selectUserSelections,
    selectSinglesStake,
} from './userSelectionsSelectors';

import {
    selectSelectionDetailsById,
    selectSelectionDetails,
} from './selectionDetailsSelectors';

import {
    selectFreebetById,
} from './freeBetSelectors';

import {
    calculateSingleBetPayout,
    calculateSinglesTabAllSinglesPayout,
} from '~Betslip/utils/payoutCalculators';

import {
    selectAvailableSingles,
} from './availableBetTypesSelectors';

export const selectSinglesNoAvailableReturns = createSelector(
    selectAvailableSingles,
    singles => Boolean(singles.filter(single => single.potential_returns_multiplier === null).length)
);

export const selectSinglePayout = createSelector(
    [
        selectSelectionDetailsById,
        selectUserSelectionById,
        selectFreebetById,
    ],
    (selectionDetails, userSelection, freebet) => {
        return calculateSingleBetPayout(selectionDetails, userSelection, Number(freebet?.value));
    }
);

export const selectAllSinglesPayout = createSelector(
    [
        selectSinglesStake,
        selectSelectionDetails,
        selectUserSelections,
        selectSinglesNoAvailableReturns,
    ],
    (singlesStake, selectionDetails, userSelections, noAvailableReturns) => {
        let payout = 0;
        if (singlesStake > 0) {
            payout = noAvailableReturns ? i18n.t('betslip.na') : calculateSinglesTabAllSinglesPayout(userSelections, selectionDetails);
        }

        return payout;
    }
);
